import { z } from 'zod';

export const PlacePriceTableAutoApplyBodySchema = z.object({
  enabled: z.boolean(),
});

export const PlacePriceTableAutoApplyResponseSchema = z.object({
  enabled: z.boolean(),
});

export type PlacePriceTableAutoApplyBody = z.infer<typeof PlacePriceTableAutoApplyBodySchema>;
export type PlacePriceTableAutoApplyResponse = z.infer<
  typeof PlacePriceTableAutoApplyResponseSchema
>;
